/* eslint no-console: 0 */
/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useLoading } from '../../../../../presentation/contexts/loading'

import { useMe } from '../../../../../presentation/contexts/me'
import { useModal } from '../../../../../presentation/contexts/modal'
import { usePage } from '../../../../../presentation/contexts/page'
import { useSnackbar } from '../../../../../presentation/contexts/snackbar'

import { createTime } from '../../../../../presentation/helpers/helper-date'
import HelperList from '../../../../../presentation/helpers/helper-list'
import { parseToNumberOrNull } from '../../../../../presentation/helpers/helper-number'
import { formatDataForm, removeProperties } from '../../../../../presentation/helpers/helper-object'
import { priceToNumber } from '../../../../../presentation/helpers/helper-price'
import { stringToList } from '../../../../../presentation/helpers/helper-string'

import ProductEditor from '../../../../../presentation/pages/dashboard/menu/products/editor'
import OptionModelForm from '../../../../../presentation/pages/dashboard/menu/products/editor/option-model-form'
import { theme } from '../../../../../presentation/styles/theme'
import { makeCategory } from '../../../../usecases/categories/load-category-factory'
import { makeOptionModel } from '../../../../usecases/option-models/load-option-model-factory'
import { apiToFormik, makeProduct } from '../../../../usecases/products/load-product-factory'

const MakeProductEditor = () => {
  const { me } = useMe()
  const { setHeader } = usePage()
  const location = useLocation()
  const history = useHistory()
  const { toggleVisibility, updateContent } = useModal()
  const { setIsShowing, setText, setType } = useSnackbar()
  const { onSetLoading } = useLoading()

  const [currentProduct, setCurrentProduct] = useState<any | any>(null)
  const [categories, setCategories] = useState([])
  const [optionModels, setOptionModels] = useState([])
  const [preferenceItemsOfOptionModels, setPreferenceItemsOfOptionModels] = useState([])
  const [optionModelUpdated, setOptionModelUpdated] = useState(false)
  const [organizationDataToSubmit, setOrganizationDataToSubmit] = useState({} as any)
  const [initialFormData, setInitialFormData] = useState<any>(null)
  const [initialOrganizationFormData, setInitialOrganizationFormData] = useState<any>(null)

  // Get product by location and set form
  useEffect(() => {
    (async () => {
      const { item } = location?.state as any
      setHeader({
        title: item ? 'Editar produto' : 'Novo produto',
        goTo: '/dashboard/products/',
      })
      onSetLoading(true)
      const {
        initialData,
        initialOrganizationData,
      } = await apiToFormik(item)

      setCurrentProduct(item)
      setInitialFormData(initialData)
      setInitialOrganizationFormData(initialOrganizationData)
      onSetLoading(false)
    })()
  }, [location, setHeader])

  // Get options models by API
  useEffect(() => {
    (() => {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      makeCategory(stablishmentId)
        .load()
        .then((data) => {
          const dataFormatted = data.categories.map((option: any) => ({
            label: option.name,
            value: option.id,
          }))
          setCategories(dataFormatted)
        })
      makeOptionModel(stablishmentId)
        .load()
        .then((data) => {
          const dataFormatted = data.optionModels.map((option: any) => ({
            label: option.name,
            value: option.id,
          }))
          setOptionModels(dataFormatted)
          setOptionModelUpdated(false)
        })
    })()
  }, [me, optionModelUpdated])

  // Update preference items list when update option model id
  useEffect(() => {
    (async () => {
      const { optionModelId } = organizationDataToSubmit
      if (!parseToNumberOrNull(optionModelId)) {
        setPreferenceItemsOfOptionModels([])
        return
      }
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      const response = await makeOptionModel(stablishmentId).load(optionModelId)

      setPreferenceItemsOfOptionModels(JSON.parse(response.optionModel.preferenceItems))
    })()
  }, [me, organizationDataToSubmit])

  const formatSelectFieldsToSubmit = (fields: string[], data: any, isToUpdateProduct: boolean) => {
    const itemToSubmit = { ...data }

    fields.forEach((field) => {
      const currentFieldIsEmpty = !!(itemToSubmit[field] === '' || !itemToSubmit[field])

      if (isToUpdateProduct && currentFieldIsEmpty) {
        itemToSubmit[field] = -1
      } else if (currentFieldIsEmpty) {
        delete itemToSubmit[field]
      }
    })

    return itemToSubmit
  }

  const optionModelSubmit = async (items:any): Promise<void> => {
    const { name, preferenceItems } = items

    const data = {
      name,
      preferenceItems: JSON.stringify(preferenceItems),
    }

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      await makeOptionModel(stablishmentId).post(data)
      toggleVisibility()
      setOptionModelUpdated(true)

      setText('Salvo com sucesso!')
      setIsShowing(true)
    } catch (err) {
      console.log(err)
    }
  }

  const optionModelForm = [
    {
      items: [
        {
          name: 'name',
          component: 'Input',
          value: '',
          placeholder: 'Ex: opçoes de carne',
          title: 'Nome do modelo',
          label: 'Nome do modelo',
          style: { width: '75%', marginBottom: '20px' },
          required: true,
          validations: 'inputRequired',
        },
        {
          name: 'preferenceItems',
          component: 'MultipleInput',
          value: [''],
          placeholder: 'Digite aqui',
          title: 'Cadastre os opcionais do produto',
          label: 'Cadastre os opcionais do produto',
          required: true,
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Salvar',
          submittingText: 'Salvando...',
          style: { background: theme.colors.blue, width: '60%', marginTop: '45px' },
        },
      ],
    },
  ]

  const openModal = () => {
    updateContent({
      title: 'Novo',
      component: () => <OptionModelForm dataForm={optionModelForm} onSubmit={optionModelSubmit} />,
    })
    toggleVisibility()
  }

  const dataForm = [
    {
      items: [
        {
          title: 'Dados do produto',
          subtitle: '',
          component: 'Title',
        },
        {
          name: 'file',
          label: 'Imagem do produto',
          title: 'Imagem do produto',
          component: 'InputUpload',
          required: true,
          description: 'Tamanho sugerido 1080x1080px',
          // validations: 'inputRequired',
        },
        {
          name: 'goToKitchen',
          component: 'InputRadio',
          value: '',
          title: 'Este produto será enviado para cozinha?',
          label: 'Este produto será enviado para cozinha?',
          required: true,
          options: [{ label: 'Sim', value: true }, { label: 'Não', value: false }],
          validations: 'inputRequired',
        },
        {
          component: 'InputGroup',
          inputs: [
            {
              component: 'Input',
              name: 'name',
              label: 'Nome',
              title: 'Nome',
              value: '',
              required: true,
              placeholder: 'Digite aqui',
              validations: 'inputRequired',
            },
            {
              component: 'InputMask',
              mask: 'CURRENCY',
              name: 'price',
              label: 'Preço de venda (R$)',
              title: 'Preço de venda (R$)',
              value: '',
              required: true,
              placeholder: 'Digite aqui',
              validations: 'inputRequired',
            },
          ],
        },
        {
          name: 'description',
          component: 'Textarea',
          value: '',
          placeholder: 'Digite aqui',
          title: 'Descrição',
          label: 'Descrição',
          required: true,
          validations: 'inputRequired',
        },
        {
          title: 'Tempo de preparo',
          subtitle: '',
          component: 'Title',
        },
        {
          name: 'hasPreparationTime',
          component: 'InputRadio',
          value: '',
          title: 'Deseja colocar tempo de preparo do produto?',
          label: 'Deseja colocar tempo de preparo do produto?',
          required: true,
          options: [{ label: 'Sim', value: true }, { label: 'Não', value: false }],
          validations: 'inputRequired',
        },
        {
          component: 'InputGroup',
          style: { width: '60%' },
          dependencies: [{ name: 'hasPreparationTime', value: 'true' }],
          inputs: [
            {
              component: 'Input',
              name: 'hour',
              label: 'Hora',
              title: 'Hora',
              type: 'number',
              min: 0,
              value: '',
              placeholder: 'Ex: 1h',
            },
            {
              component: 'Input',
              name: 'minute',
              label: 'Minuto',
              title: 'Minuto',
              type: 'number',
              value: '',
              min: 0,
              placeholder: 'Ex: 48min',
            },
          ],
        },
        {
          title: 'Controle de estoque',
          subtitle: '',
          component: 'Title',
        },
        {
          name: 'hasStock',
          component: 'InputRadio',
          value: '',
          title: 'Deseja realizar o controle de estoque?',
          label: 'Deseja realizar o controle de estoque?',
          required: true,
          options: [{ label: 'Sim', value: true }, { label: 'Não', value: false }],
          validations: 'inputRequired',
        },
        {
          name: 'stock',
          component: 'Input',
          value: '0',
          type: 'number',
          placeholder: 'Digite aqui',
          title: 'Digite a quantidade',
          label: 'Digite a quantidade',
          min: 0,
          styleContainer: { width: '25%' },
          validations: '',
          dependencies: [{ name: 'hasStock', value: 'true' }],
        },
        {
          name: 'button',
          component: 'Button',
          title: 'Salvar',
          submittingText: 'Salvando...',
          style: { background: theme.colors.blue, width: '35%', marginTop: '45px' },
        },
      ],
    },
  ]

  const organizationForm = [{
    items: [
      {
        title: 'Organização',
        subtitle: '',
        component: 'Title',
      },
      {
        name: 'categoryId',
        component: 'Select',
        value: '',
        placeholder: 'Digite aqui',
        required: true,
        title: 'Categoria',
        label: 'Categoria',
        styleContainer: { marginBottom: '35px' },
        options: [...categories],
      },
      {
        name: 'optionModelId',
        component: 'Select',
        value: '',
        placeholder: 'Digite aqui',
        title: 'Modelos de opções',
        label: 'Modelos de opções',
        hasPlusButton: true,
        handlePlusButton: openModal,
        options: optionModels,
      },
      {
        name: 'preferenceItems',
        component: 'InputArray',
        value: [],
        standardItems: preferenceItemsOfOptionModels,
        title: 'Cadastro de opcionais',
        label: 'Cadastro de opcionais',
        submitTitle: 'Adicionar opcionais',
      },
    ],
  }]

  const onSubmit = async (items:any): Promise<void> => {
    let itemToSubmit = { ...items, ...organizationDataToSubmit }
    const formData = new FormData()
    const isToUpdateProduct = !!currentProduct

    const selectFields = ['categoryId', 'optionModelId']
    itemToSubmit = formatSelectFieldsToSubmit(selectFields, itemToSubmit, isToUpdateProduct)

    const itemGroup = [
      { name: 'optionModelId', adapter: parseToNumberOrNull },
      { name: 'price', adapter: priceToNumber },
      { name: 'stock', adapter: Number },
      { name: 'categories', adapter: stringToList },
      { name: 'preferenceItems', adapter: HelperList.transformEmptyListInNull },
      { name: 'hour', dependency: 'hasPreparationTime', valueIfDependencyIsInvalid: 0 },
      { name: 'minute', dependency: 'hasPreparationTime', valueIfDependencyIsInvalid: 0 },
      { name: 'stock', dependency: 'hasStock', valueIfDependencyIsInvalid: null },
    ]
    itemToSubmit = formatDataForm(itemToSubmit, itemGroup)

    if (itemToSubmit.hasPreparationTime) {
      itemToSubmit.preparationTime = createTime(items.hour, items.minute)
    }
    if (itemToSubmit.preferenceItems) {
      itemToSubmit.preferenceItems = JSON.stringify(itemToSubmit.preferenceItems)
    }

    const itemsToDelete = ['button', 'undefined', 'category', 'hour', 'minute']
    if (itemToSubmit.file.uuid) {
      itemsToDelete.push('file')
    }
    itemToSubmit = removeProperties(itemToSubmit, itemsToDelete)

    Object.keys(itemToSubmit).forEach((key) => {
      formData.append(key, itemToSubmit[key])
    })

    try {
      if (!me) return
      const stablishmentId = me.stablishments[0].id
      if (isToUpdateProduct) {
        await makeProduct(stablishmentId).patch(currentProduct.id, formData)
      } else {
        await makeProduct(stablishmentId).post(formData)
      }

      setType('success')
      setText('Salvo com sucesso!')
      setIsShowing(true)
      history.push('/dashboard/products')
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <ProductEditor
      dataForm={dataForm}
      initialFormData={initialFormData}
      initialOrganizationFormData={initialOrganizationFormData}
      organizationForm={organizationForm}
      setOrganizationDataToSubmit={setOrganizationDataToSubmit}
      onSubmit={onSubmit}
    />
  )
}

export default MakeProductEditor
